import { render, staticRenderFns } from "./DashboardCampaignResultDialog.vue?vue&type=template&id=2cea73e3&scoped=true&"
import script from "./DashboardCampaignResultDialog.vue?vue&type=script&lang=js&"
export * from "./DashboardCampaignResultDialog.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCampaignResultDialog.vue?vue&type=style&index=0&id=2cea73e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cea73e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VChip,VDialog,VDivider,VFlex,VIcon,VLayout})
